export const RadioChecked = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="#7F56D9" />
    <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#7F56D9" />
    <rect x="6" y="6" width="8" height="8" rx="4" fill="white" />
  </svg>
)
